import type { ReactNode } from 'react';
import { useSesion } from '../context/Sesion';
import type { Rol } from '../types/api';

/** Muestra `children` solo si el usuario tiene el rol (o uno superior). */
export function SiPuede({ rol, children, si_no = null }: { rol: Rol; children: ReactNode; si_no?: ReactNode }) {
  return <>{useSesion().puede(rol) ? children : si_no}</>;
}

export function SinPermiso({ rol }: { rol: Rol }) {
  return (
    <div className="aviso aviso-error" role="alert">
      Esta página necesita el rol <code>{rol}</code>. Pídelo a IT (proyecto <code>dwh</code> en auth.fonestar.com).
    </div>
  );
}
